import { render, staticRenderFns } from "./card-payment-modal.vue?vue&type=template&id=12374dd3&"
import script from "./card-payment-modal.vue?vue&type=script&lang=js&"
export * from "./card-payment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports